import React from 'react'
import { IconButton, Tooltip } from '@mui/material'

export interface TooltipsControlProps {
  enabled?: boolean
  onToggle?: (enabled: boolean) => void
  disabled?: boolean
  theme?: 'dark' | 'light'
}

export const TooltipsControl: React.FC<TooltipsControlProps> = ({
  enabled = false,
  onToggle,
  disabled = false,
  theme = 'dark'
}) => {
  const handleToggle = () => {
    if (!disabled && onToggle) {
      onToggle(!enabled)
    }
  }

  return (
    <Tooltip title={enabled ? "Hide Tooltips" : "Show Tooltips"} placement="top">
      <IconButton
        size="small"
        onClick={handleToggle}
        disabled={disabled}
        sx={{
          width: '32px',
          height: '32px',
          border: '1px solid',
          borderColor: enabled 
            ? 'rgba(25, 118, 210, 0.8)' // Highlight when active
            : theme === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
          backgroundColor: enabled ? 'rgba(25, 118, 210, 0.8)' : 'transparent',
          color: enabled 
            ? 'white' 
            : theme === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: enabled 
              ? 'rgba(25, 118, 210, 0.9)'
              : theme === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)',
            borderColor: enabled
              ? 'rgba(25, 118, 210, 0.9)'
              : theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'
          },
          '&.Mui-disabled': {
            opacity: 0.5,
            borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
            color: theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'
          }
        }}
      >
        {/* Custom tooltip/info icon */}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          {/* Speech bubble outline */}
          <rect x="2" y="3" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
          
          {/* Speech bubble tail */}
          <path d="M6 11 L5 13 L7 11" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
          
          {/* Info lines inside bubble */}
          <line x1="5" y1="5.5" x2="11" y2="5.5" stroke="currentColor" strokeWidth="1" />
          <line x1="5" y1="7" x2="9" y2="7" stroke="currentColor" strokeWidth="1" />
          <line x1="5" y1="8.5" x2="10" y2="8.5" stroke="currentColor" strokeWidth="1" />
        </svg>
      </IconButton>
    </Tooltip>
  )
} 